import { render, staticRenderFns } from "./SimulacionManager.vue?vue&type=template&id=141d0a40&scoped=true"
import script from "./SimulacionManager.vue?vue&type=script&lang=js"
export * from "./SimulacionManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141d0a40",
  null
  
)

export default component.exports